import { getFromStorage, saveToStorage } from './used-vue/api/Storage';
window.getCookieValue = getFromStorage;
window.setCookieValue = saveToStorage;

import NumberFormat from './used-vue/api/NumberFormat';
window.number_format = NumberFormat;